<template>
    <div>
        <div
            v-for="(currentToastr, index) of visibleToastr"
            :key="index"
        >
            <div
                :class="[styles.alert_parent, 'bottom-' + (index * 16 + 4)]"
                class="z-50"
            >
                <div :class="[
                        type === 'default' ? styles.alert : styles.alert_error,
                        { 'animate__animated animate__bounceInLeft': anim }
                     ]"
                     class="min-w-[200px] md:min-w-[400px]"
                >
                    <base-icon
                        v-if="toastr[currentToastr].icon"
                        :icon="toastr[currentToastr].icon"
                        class="mr-2"
                        size="sm"
                    ></base-icon>
                    <div class="flex items-center pr-2">{{ toastr[currentToastr].content }}</div>
                    <button @click="close(index)">
                        <base-icon
                            :class="[classStyles['text-main_color-600'], classStyles['hover:text-main_color-800']]"
                            icon="times"
                            size="sm"
                        ></base-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia'

import useGenericStore from '../../common/store/generic'

export default {
  name: 'BaseToastr',
  props: {
    type: {
      type: String,
      default: 'default',
      validator (value) {
        return [
          'default', 'error'
        ].includes(value)
      }
    }
  },

  data () {
    return {
      styles: window.myStyles,
      anim: window.anim,
      classStyles: window.class_styles
    }
  },

  computed: {
    ...mapState(useGenericStore, ['toastr']), ...mapWritableState(useGenericStore, ['visibleToastr'])
  },

  watch: {
    visibleToastr (newValue) {
      if (newValue !== []) {
        setTimeout(_ => {
          this.closeAll()
        }, 6000)
      }
    }
  },

  methods: {
    close (index) {
      this.visibleToastr.splice(index, 1)
    },

    closeAll () {
      this.visibleToastr = []
    }
  }
}
</script>

<style scoped>

</style>
